import React, { Component } from 'react';

function escapeHtml(str) {
  if (typeof str !== 'string') return '';
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function formatError(error) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error instanceof Error) {
    return 'Error: ' + (error.message || error.name) + '\n\nStack:\n' + (error.stack || '(no stack trace)');
  }
  try {
    return JSON.stringify(error, Object.getOwnPropertyNames(error), 2);
  } catch (e) {
    return String(error);
  }
}

function showOverlay(error, errorInfo, onClose) {
  var old = document.getElementById('vg-error-overlay');
  if (old) old.parentNode.removeChild(old);

  document.body.style.pointerEvents = 'none';

  var stack = escapeHtml((error && error.stack) || formatError(error));
  var msg = escapeHtml((error && error.message) || 'An unexpected error occurred');
  var cstack = errorInfo && errorInfo.componentStack ? escapeHtml(errorInfo.componentStack) : null;

  var overlay = document.createElement('div');
  overlay.id = 'vg-error-overlay';
  overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;pointer-events:auto;';

  var backdrop = document.createElement('div');
  backdrop.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.45);pointer-events:auto;';

  var box = document.createElement('div');
  box.style.cssText = 'position:relative;background:#fff;border-radius:8px;padding:24px;max-width:640px;width:90%;max-height:90vh;overflow:auto;box-shadow:0 6px 16px rgba(0,0,0,0.08);pointer-events:auto;';

  var whatsapp_number = window.__WHATSAPP_NUMBER;
  var contact_dev_url = window.__CONTACT_DEV_URL;

  box.innerHTML =
    '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px">' +
      '<h3 style="margin:0;font-size:18px;font-weight:600">Something went wrong</h3>' +
      '<button id="vg-close" style="border:none;background:none;font-size:24px;cursor:pointer;padding:0 8px;line-height:1;color:#666;pointer-events:auto">&times;</button>' +
    '</div>' +
    '<div style="color:#ff4d4f;font-size:15px;margin-bottom:16px">' + msg + '</div>' +
    '<details>' +
      '<summary style="cursor:pointer;margin-bottom:8px;font-weight:500;font-size:14px;pointer-events:auto">Stack Trace</summary>' +
      '<pre style="padding:12px;background:#f5f5f5;border-radius:4px;max-height:300px;overflow:auto;font-size:12px;white-space:pre-wrap;word-break:break-all;margin:8px 0 0">' + stack + '</pre>' +
    '</details>' +
    (cstack
      ? '<details style="margin-top:16px">' +
          '<summary style="cursor:pointer;margin-bottom:8px;font-weight:500;font-size:14px;pointer-events:auto">Component Stack</summary>' +
          '<pre style="padding:12px;background:#f5f5f5;border-radius:4px;max-height:200px;overflow:auto;font-size:12px;white-space:pre-wrap;word-break:break-all;margin:8px 0 0">' + cstack + '</pre>' +
        '</details>'
      : ''
    ) +
    '<div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:24px">' +
      '<button id="vg-copy" style="padding:6px 16px;border-radius:6px;font-size:14px;cursor:pointer;border:1px solid #d9d9d9;background:#fff;line-height:22px;pointer-events:auto">Copy Error</button>' +
      (whatsapp_number ? '<button id="vg-whatsapp" style="padding:6px 16px;border-radius:6px;font-size:14px;cursor:pointer;border:1px solid #1677ff;background:#1677ff;color:#fff;line-height:22px;pointer-events:auto">Report via WhatsApp</button>' : '') +
      (contact_dev_url ? '<button id="vg-contact" style="padding:6px 16px;border-radius:6px;font-size:14px;cursor:pointer;border:1px solid #d9d9d9;background:#fff;line-height:22px;pointer-events:auto">Contact Developer</button>' : '') +
      '<button id="vg-reload" style="padding:6px 16px;border-radius:6px;font-size:14px;cursor:pointer;border:1px solid #ff4d4f;color:#ff4d4f;background:#fff;line-height:22px;pointer-events:auto">Reload Page</button>' +
    '</div>';

  overlay.appendChild(backdrop);
  overlay.appendChild(box);
  document.body.appendChild(overlay);

  document.getElementById('vg-close').onclick = function (e) { e.stopPropagation(); onClose(); };
  document.getElementById('vg-copy').onclick = function () {
    var text = formatError(error);
    if (cstack) text += '\nComponent Stack:\n' + errorInfo.componentStack;
    navigator.clipboard.writeText(text);
  };
  if (whatsapp_number) {
    document.getElementById('vg-whatsapp').onclick = function () {
      var text = formatError(error);
      window.open('https://wa.me/' + whatsapp_number + '?text=' + encodeURIComponent(text), '_blank');
    };
  }
  if (contact_dev_url) {
    document.getElementById('vg-contact').onclick = function () {
      window.open(contact_dev_url, '_blank');
    };
  }
  document.getElementById('vg-reload').onclick = function () {
    window.location.reload();
  };
}

export default class ErrorModal extends Component {
  componentDidMount() {
    window.__showError = function (error, errorInfo) {
      showOverlay(error, errorInfo, function () {
        document.body.style.pointerEvents = '';
        var el = document.getElementById('vg-error-overlay');
        if (el) el.parentNode.removeChild(el);
      });
    };
  }

  componentWillUnmount() {
    delete window.__showError;
    document.body.style.pointerEvents = '';
    var el = document.getElementById('vg-error-overlay');
    if (el) el.parentNode.removeChild(el);
  }

  render() {
    return null;
  }
}
